import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "del_icon_cavity",
  "use": "del_icon_cavity-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"del_icon_cavity\">\n<path d=\"M10.1,1.1c-4.9,0-8.9,4-8.9,8.9s4,8.9,8.9,8.9s8.9-4,8.9-8.9S15,1.1,10.1,1.1z M10.1,18c-4.4,0-8-3.6-8-8\n\ts3.6-8,8-8s8,3.6,8,8S14.5,18,10.1,18z\" />\n<path d=\"M14.9,14.9L14.9,14.9c0.2-0.2,0.2-0.5,0.1-0.7L5.9,5.1c-0.2-0.2-0.5-0.2-0.6,0L5.2,5.2C5,5.3,5,5.6,5.2,5.8\n\tl9.1,9.1C14.5,15.1,14.8,15.1,14.9,14.9z\" />\n<path d=\"M5.2,14.8L5.2,14.8c0.2,0.2,0.5,0.2,0.7,0.1L15,5.8c0.2-0.2,0.2-0.5,0-0.6l-0.1-0.1c-0.2-0.2-0.5-0.2-0.6,0\n\tl-9.1,9.1C5,14.4,5,14.7,5.2,14.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id